import React from 'react';
import { format } from 'date-fns';

import { ReactComponent as CheckIcon } from '../../../assets/images/checkIcon.svg';
import { ReactComponent as InfoIcon } from '../../../assets/images/InfoIconShaped.svg';
import { ReactComponent as RespondIcon } from '../../../assets/images/respond.svg';
import RewardInfoIcon from '../../../assets/svgComponents/RewardInfoIcon';
import ColumnFilter from '../../../components/ColumnFilter/ColumnFilter';
import Menu from '../../../components/shared/Menu/Menu';
import StatusBadge from '../../../components/shared/StatusBadge/StatusBadge';
import { CURRENCIES, DEFAULT_CURRENCY } from '../../../constants/currenciesConstants';
import RewardTypes from '../../../constants/rewardTypes';
import history from '../../../routing/history';
import urls from '../../../routing/urls';

import styles from './DisputesTable.module.scss';

const getDisputeColumns = (toggleCloseDisputeModal, toggleDeclineRequestModal, t) => [
  {
    Header: t('tableHeaders.id'),
    accessor: 'id',
    Filter: ColumnFilter,
    disableFilters: true,
  },
  {
    Header: t('tableHeaders.employer'),
    accessor: 'employer',
    Filter: ColumnFilter,
    Cell: ({ value, row }) => (
      <div
        className={styles.disputeTitle}
        onClick={() => history.push(urls.disputeDetails.replace(':id', row.original.id))}
        role="presentation"
      >
        {value}
      </div>
    ),
  },
  {
    Header: t('tableHeaders.openingTitle'),
    accessor: 'opening',
    Filter: ColumnFilter,
  },
  {
    Header: t('tableHeaders.candidate'),
    accessor: 'candidate',
    Filter: ColumnFilter,
  },
  {
    Header: t('tableHeaders.reward'),
    accessor: 'reward',
    Filter: ColumnFilter,
    minWidth: 120,
    Cell: ({ row, value }) =>
      row.original.rewardable_type === RewardTypes.MONETARY_REWARD ? (
        `${CURRENCIES[row.original.reward_currency ?? DEFAULT_CURRENCY]}${value}`
      ) : (
        <span>
          {value} <RewardInfoIcon />
        </span>
      ),
  },
  {
    Header: t('tableHeaders.disputeId'),
    accessor: 'uuid',
    minWidth: 165,
    Filter: ColumnFilter,
  },
  {
    Header: t('tableHeaders.disputeDate'),
    accessor: 'created_at',
    minWidth: 150,
    Filter: ColumnFilter,
    Cell: ({ value }) => {
      const date = new Date(value);
      return format(new Date(date.getTime() + date.getTimezoneOffset() * 60000), 'MM/dd/yyyy');
    },
  },
  {
    Header: t('tableHeaders.status'),
    accessor: 'open',
    minWidth: 125,
    Filter: ColumnFilter,
    Cell: ({ row, value }) =>
      row.original.request_to_close && row.original.open ? (
        <StatusBadge
          type="dispute"
          value="respond"
          icon={RespondIcon}
          onClick={() => toggleDeclineRequestModal(row.original.id)}
        />
      ) : (
        <StatusBadge type="dispute" value={value ? 'disputed' : 'resolved'} icon={value ? InfoIcon : CheckIcon} />
      ),
  },
  {
    Header: '',
    accessor: 'multi-selected',
    width: 60,
    minWidth: 60,
    Cell: ({ row }) => (
      <Menu
        items={[
          {
            title: t('actions.expandDetails'),
            action: () => history.push(urls.disputeDetails.replace(':id', row.original.id)),
          },
          row.original.open
            ? {
                title: t('dispute.closeDispute'),
                action: () => toggleCloseDisputeModal(row.original),
              }
            : {},
          row.original.request_to_close && row.original.open
            ? {
                title: t('actions.declineCloseRequest'),
                action: () => toggleDeclineRequestModal(row.original.id),
              }
            : {},
          {
            title: t('actions.contactSupport'),
            action: () => window.open(process.env.REACT_APP_DISPUTES_PORTAL_URL, '_blank'),
          },
        ]}
      />
    ),
  },
];

export default getDisputeColumns;
